import { render, staticRenderFns } from "./RespOrder.vue?vue&type=template&id=34f5f816&lang=html"
import script from "./RespOrder.vue?vue&type=script&lang=js"
export * from "./RespOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports